import { render, staticRenderFns } from "./global-notification-page.html?vue&type=template&id=5d1f6a08&scoped=true&"
import script from "./global-notification-page.js?vue&type=script&lang=js&"
export * from "./global-notification-page.js?vue&type=script&lang=js&"
import style0 from "./global-notification-page.scss?vue&type=style&index=0&id=5d1f6a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f6a08",
  null
  
)

export default component.exports